var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMalt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.79 186.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.85,52.3c-14.1-14.1-29.16-5-38.59,4.46l-89,89c-9.43,9.43-19.29,23.75-4.45,38.59s29.16,5,38.58-4.45l89.05-89C164.82,81.46,174,66.4,159.85,52.3Z",
    transform: "translate(0 -25.35)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.78,48.66,93.64,67.51l19.19-19.19c1.3-1.31,2.62-2.52,4-3.66-2-10.14-7.79-19.31-23.15-19.31s-21.17,9.2-23.17,19.37C71.89,46,73.33,47.2,74.78,48.66Z",
    transform: "translate(0 -25.35)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.82,188.71,93.64,169.53,74.79,188.37c-1.43,1.43-2.85,2.74-4.27,4,2.16,10.34,8.27,19.81,23.11,19.81s21-9.52,23.12-19.89C115.44,191.12,114.12,190,112.82,188.71Z",
    transform: "translate(0 -25.35)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.78,94.36H30.43C17.1,94.36,0,98.56,0,118.5c0,14.88,9.52,21,19.89,23.13C21.12,140.21,66.78,94.36,66.78,94.36Z",
    transform: "translate(0 -25.35)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.43,95.33c-1.14,1.34-46.9,47.31-46.9,47.31h35.83c13.33,0,30.43-3.15,30.43-24.14C186.79,103.11,177.6,97.33,167.43,95.33Z",
    transform: "translate(0 -25.35)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.69,82.43l6.5-6.49L66.34,57.09C56.92,47.67,42.6,37.8,27.76,52.64c-10.88,10.88-8.47,21.47-2.69,30.07C26.82,82.58,78.69,82.43,78.69,82.43Z",
    transform: "translate(0 -25.35)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.57,154.57l-6.51,6.51,19.19,19.19c9.43,9.43,24.49,18.55,38.59,4.46,10.52-10.53,8.11-21.58,2.29-30.43C160.26,154.44,108.57,154.57,108.57,154.57Z",
    transform: "translate(0 -25.35)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalt);
export default __webpack_public_path__ + "static/media/malt.d172e8dbca4708a8a8368366a393bd12.svg";
export { ForwardRef as ReactComponent };